import { env } from '#lib';

const SITE_KEY = env.get('VITE_GOOGLE_RECAPTCHA_V3_SITE_KEY');

export const useReCaptchaV3 = () => {
  const init = async (action: string) => {
    if (!window.grecaptcha?.execute) return;

    try {
      return await window.grecaptcha.execute(SITE_KEY, {
        action
      });
    } catch (err: any) {
      // FIXME: Log this properly
      console.error(err);
    }
  };

  return { init };
};
